export default "__VITE_ASSET__Mdy3Wr$T__"